import './App.css';
import {Table} from "./components/Table";
import React from 'react';

function App() {
  return (
    <div className='bg-dark pb-4'>
      <h1 className='text-center text-light'>Dummy Data</h1>
      <Table />
    </div>
  );
}

export default App;
